import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { compose, graphql, Query, WriteQuery } from "react-apollo";
import { getComptes } from "../../api/queries/comptes.queries";
import { getPlan } from "../../api/queries/plan.queries";

import {
  getTransactions,
  getFournisseurs
} from "../../api/queries/transactions.queries";
import {
  setFournisseur,
  setCategorie,
  setTransaction
} from "../../api/queries/transactions.mutations";
import { useAuthState } from "../Context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faCheckCircle,
  faChevronRight,
  faChevronLeft,
  faCircle,
  faPencilAlt,
  faRemove,
  faMoneyBill,
  faScroll
} from "@fortawesome/free-solid-svg-icons";
import PengeAlert from "../components/PengeAlert";
import AddAccountButton from "./AddAccountButton";
import Loader from "../components/Loader";
import { displayFloatAmount, displayCurrency } from "../../services/functions";
import { selectStyles, selectTheme, copyToClipboard, notify } from "../generic";
import { login, updatePassword } from "../../api/queries/utilisateur.mutations";
import Transaction from "./Transactions/Transaction";

function Transactions({
  identifier,
  utilisateurId,
  entreprise,
  updateFournisseur,
  updateTransaction,
  updateCategorie,
  addedFournisseurs = [],
  selectedFournisseur = {}
}) {
  //  return <p>id : {identifier}</p>;

  return (
    <Query query={getPlan} variables={{ entreprise }}>
      {({
        loading: loadingPlan,
        error: errorPlan,
        data: dataPlan = {},
        refetch: refetchPlan
      }) => {
        if (loadingPlan) return <Loader />;

        return (
          <Query
            query={getFournisseurs}
            variables={{ utilisateurId, entreprise }}
          >
            {({
              loading: loadingFournisseurs,
              error: errorFournisseurs,
              data: dataFournisseurs = {},
              refetch: refetchFournisseurs
            }) => {
              const fournisseurs = [
                {
                  label: "Aucun",
                  value: -1
                }
              ];

              if (dataFournisseurs.getFournisseurs) {
                if (dataFournisseurs.getFournisseurs.length) {
                  dataFournisseurs.getFournisseurs.forEach(fournisseur => {
                    fournisseurs.push({
                      label: fournisseur.name,
                      value: fournisseur.id
                    });
                  });
                }
              }
              return (
                <Query
                  query={getTransactions}
                  variables={{
                    utilisateurId,
                    comptes: [identifier],
                    from: 0,
                    to: 100
                  }}
                >
                  {({ loading, error, data = {}, refetch }) => {
                    if (loading) return <Loader />;
                    if (error) return "Erreur !";

                    const lines = new Map();

                    data.getTransactions.forEach(transaction => {
                      const formattedDate = moment
                        .utc(transaction.date)
                        .locale("fr-fr")
                        .format("dddd D/MM/Y")
                        .toLowerCase();
                      if (!lines.has(formattedDate))
                        lines.set(formattedDate, []);
                      const day = lines.get(formattedDate);

                      let children = [];

                      if (!transaction.parent) {
                        if (transaction.splitted) {
                          const matchingChildren = data.getTransactions.filter(
                            ({ parent }) => parent === transaction.id
                          );

                          console.log({ matchingChildren });

                          children = matchingChildren.map(child => (
                            <Transaction
                              utilisateurId={utilisateurId}
                              transaction={child}
                              dataPlan={dataPlan}
                              updateFournisseur={updateFournisseur}
                              updateTransaction={updateTransaction}
                              updateCategorie={updateCategorie}
                              addedFournisseurs={addedFournisseurs}
                              selectedFournisseur={selectedFournisseur}
                              refetch={refetch}
                              fournisseurs={fournisseurs}
                              entreprise={entreprise}
                              child
                              parentData={transaction}
                            />
                          ));

                          console.log({ children });
                        }

                        day.push(
                          <Transaction
                            utilisateurId={utilisateurId}
                            transaction={transaction}
                            dataPlan={dataPlan}
                            updateFournisseur={updateFournisseur}
                            updateCategorie={updateCategorie}
                            addedFournisseurs={addedFournisseurs}
                            updateTransaction={updateTransaction}
                            selectedFournisseur={selectedFournisseur}
                            refetch={refetch}
                            fournisseurs={fournisseurs}
                            entreprise={entreprise}
                            children={children}
                          />
                        );
                      }
                    });

                    const daysList = Array.from(lines.keys());

                    let content = Array.from(lines.values()).map(
                      (line, index) => (
                        <ul className="dayBlock">
                          <div className="dayTitle">Le {daysList[index]}</div>
                          {line}
                        </ul>
                      )
                    );

                    if (!lines.size)
                      content = (
                        <p className="noLinesWarning">
                          Aucune transaction récente à afficher
                        </p>
                      );

                    return <>{content}</>;
                  }}
                </Query>
              );
            }}
          </Query>
        );
      }}
    </Query>
  );
}

function AccountTransactions({
  identifier,
  setFournisseurMutation,
  setTransactionMutation,
  setCategorieMutation
}) {
  const navigate = useNavigate();
  const authContext = useAuthState(); //read user de
  const [addedFournisseurs, setAddedFournisseurs] = useState([]);
  const [selectedFournisseur, setSelectedFournisseur] = useState({});

  const { userDetails = {} } = authContext;
  const {
    id: utilisateurId,
    login,
    email,
    token,
    entreprises = []
  } = userDetails;

  const _mutateSetCategorie = async ({
    utilisateurId,
    frequenceId,
    produitId,
    refetch
  }) => {
    try {
      return setCategorieMutation({
        variables: {
          utilisateurId,
          frequenceId,
          produitId
        }
      })
        .then(({ data }) => {
          //    const { type, message, details } = data.setCategorie;
          console.log(data);

          notify("success", "Association effectuée");
        })
        .finally(() => refetch());
    } catch (error) {
      notify("error", error.message);
    }
  };

  const _mutateSetFournisseur = async ({
    utilisateurId,
    name,
    fournisseurId,
    cleanDescription,
    entreprise,
    montant,
    frequencyType = "unique",
    referenceDate,
    refetch
  }) => {
    try {
      return setFournisseurMutation({
        variables: {
          utilisateurId,
          name,
          fournisseurId,
          cleanDescription,
          entreprise,
          montant,
          frequencyType,
          referenceDate
        }
      }).then(({ data }) => {
        const { type, message, details } = data.setFournisseur;
        const rawFournisseur = JSON.parse(details);
        const fournisseur = {
          value: rawFournisseur.id,
          label: rawFournisseur.name
        };

        if (type === "success") {
          setAddedFournisseurs([...addedFournisseurs, fournisseur]);

          setSelectedFournisseur(fournisseur);

          console.log(fournisseur);

          notify("success", message);

          refetch();
        } else {
          notify("error", message);
        }
      });
    } catch (error) {
      notify("error", error.message);
    }
  };

  const _mutateSetTransaction = async ({
    utilisateurId,
    transactionId,
    montant,
    tva,
    refetch
  }) => {
    try {
      return setTransactionMutation({
        variables: {
          utilisateurId,
          transactionId,
          montant,
          tva
        }
      }).then(({ data }) => {
        const { type, message, details } = data.setTransaction;

        if (type === "success") {
          notify("success", message);

          refetch();
        } else {
          notify("error", message);
        }
      });
    } catch (error) {
      notify("error", error.message);
    }
  };

  return (
    <Query
      query={getComptes}
      variables={{ utilisateurId }}
      fetchPolicy="no-cache"
    >
      {({ loading, error, data = {}, refetch }) => {
        if (loading) return <Loader />;
        if (error) return "Erreur !";

        const { getComptes = [] } = data;

        const compteDetails = getComptes.filter(
          compte => compte.identifiant === identifier
        );

        const { name, balance, retrievalDate } = compteDetails[0];

        let displayBalance = (
          <p className={`balance ${balance > 0 ? "positive" : "negative"}`}>
            {balance} €
          </p>
        );

        return (
          <>
            {displayBalance}
            <a className="prefixIcon" onClick={() => navigate("/")}>
              <FontAwesomeIcon icon={faChevronLeft} size="md" />
            </a>
            <h1 className="dashboardTitle prefixedByIcon">Transactions</h1>
            <p className="subtitle prefixedByIcon">Compte "{name}"</p>
            <Transactions
              utilisateurId={utilisateurId}
              entreprise={entreprises[0].entrepriseId}
              identifier={identifier}
              updateFournisseur={_mutateSetFournisseur}
              updateTransaction={_mutateSetTransaction}
              updateCategorie={_mutateSetCategorie}
              addedFournisseurs={addedFournisseurs}
              selectedFournisseur={selectedFournisseur}
            />
          </>
        );
      }}
    </Query>
  );
}

export default compose(
  graphql(setFournisseur, {
    name: "setFournisseurMutation"
  }),
  graphql(setTransaction, {
    name: "setTransactionMutation"
  }),
  graphql(setCategorie, {
    name: "setCategorieMutation"
  })
)(AccountTransactions);
